import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleItalic } from 'roosterjs-editor-api';

const italic: RibbonButton = {
    key: 'italic',
    title: () => strings.italic,
    imageSrc: require('../svg/italic.svg'),
    shortcutWin: 'Ctrl+I',
    shortcutMac: '⌘+I',
    buttonState: formatState =>
        formatState.isItalic ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleItalic(plugin.getEditor()),
};

export default italic;
